export function getProductType(variantKey: string): string
export function getProductType(variantKey: null | undefined): null
export function getProductType(
  variantKey: string | null | undefined
): string | null
export function getProductType(variantKey: string | null | undefined) {
  return getVariantKeyAttributes(variantKey)[0]?.toUpperCase() || null
}

export function getVariantKeyAttributes(variantKey: string): string[]
export function getVariantKeyAttributes(variantKey: null | undefined): string[]
export function getVariantKeyAttributes(
  variantKey: string | null | undefined
): string[]
export function getVariantKeyAttributes(variantKey: string | null | undefined) {
  return variantKey?.split("-").map(attribute => attribute.toUpperCase()) || []
}
